module.exports = __webpack_public_path__ + "static/media/kompensation.a5c9df3c.mp3";